export const FileType = [
    'application/msword',
    'application/x-gzip',
    'text/plain',
    'image/jpeg',
    'image/jpeg',
    'application/pdf',
    'application/vnd.ms-powerpoint',
    'image/svg+xml',
    'application/vnd.ms-excel',
    'application/zip',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/x-zip-compressed',
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow", //ppsx
    "application/vnd.ms-excel.sheet.macroEnabled.12"
];
export const FileExtension = [
    'xls',
    'xlsx',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'pdf',
    'pps',
    'ppsx',
    'csv',
    'txt',
    'jpg',
    'jpeg',
    'png',
    'zip',
    'xlsm',
    'xlsb',
    'rar',
    '7z',
    'msg',
    'zipx',
    {
        type: 'reg',
        value: '(.*)\\.7z\\.[0-9]{1,}$',
        desc: '7z'
    },
    {
        type: 'reg',
        value: '(.*)\\.(part[0-9]{1,}\\.rar)$',
        desc: 'rar'
    },
    {
        type: 'reg',
        value: '(.*)\\.(zip\\.z[0-9]{1,})$',
        desc: 'zip'
    },
    {
        type: 'reg',
        value: '(.*)\\.(z[0-9]{1,})$',
        desc: 'zip'
    },
    {
        type: 'reg',
        value: '(.*)\\.(zx[0-9]{1,})$',
        desc: 'zip'
    }
];
export const checkIsValidExtension = fileName => {
    if (!fileName.includes('.')) return false;
    const fileNameArray = fileName.split('.');
    if (FileExtension.filter(v => typeof v == 'string').includes(fileNameArray[fileNameArray.length - 1].toLowerCase())) return true
    if (FileExtension.filter(v => typeof v == 'object' && v.type == 'reg').some(v => new RegExp(v.value).test(fileName))) return true
    return false
};

export const displayFileExtensions = () => {
    const exts = FileExtension.map(v => {
        if (typeof v == 'string') {
            return v
        } else if (typeof v == 'object' && v.type == 'reg') {
            return v.desc
        }
    })
    return [...new Set(...exts)]
}